exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".win-wrap{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.flex-wrap{position:relative}.container4{display:flex;flex-direction:column;z-index:9}.container4 h2{padding:25px}.canvas{z-index:1;position:absolute}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-72e39216","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Winner.vue
// module id = 32
// module chunks = 0